import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";


class CondPagtoFrame extends Component {
    state = {
        lista: [],
        pessoa: 0,
        codigo: {
            key: '0',
            label: '',
            qtdeParc: 0,
            parcelas: 0,
        },
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: '',
                    qtdeParc: 0,
                    parcelas: 0,
                },
            })
        }
    }

    componentDidMount() {
        this.getListaRegistros();
    }

    getListaRegistros = () => {
        // console.log('CondPagtoFrame - getListaRegistros: ', this.props.pessoa)

        this.setState({ lista: [], pessoa: this.props.pessoa })
        axios.get('/condPagto/lista', {
            params: {
                pessoa: this.props.pessoa
            }
        }).then(response => {
            const { data } = response;

            // console.log('CondPagtoFrame - getListaRegistros: ', data)

            const lista = data.map(regList => {
                return {
                    key: regList.cp_idf,
                    label: regList.cp_descricao,
                    qtdeParc: regList.cp_qtde_parc,
                    parcelas: regList.cp_parcelas,
                }
            });
            if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                lista.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
            }
            this.setState({
                lista,
            })
        }).catch(error => {
            console.error(error.response);
        })
    };

    onChange = event => {
        const value = event.target.value;
        const id = event.target.id;
        this.setState({ [id]: value });
        const indCondPagto = value ? this.state.lista.findIndex(registro => String(registro.key) === String(value.key)) : -1;
        const state = {};
        state[id] = {
            key: value.key,
            label: value.label,
            qtdeParc: this.state.lista[indCondPagto].qtdeParc,
            parcelas: this.state.lista[indCondPagto].parcelas,
        };
        this.props.onChange(state);
    };






    render() {
        const { label, id, width } = this.props;
        const { lista, codigo } = this.state;

        // console.log('CondPagtoFrame.state: ', this.state);
        // console.log('CondPagtoFrame.props: ', this.props);

        if (this.props.pessoa != this.state.pessoa) {
            this.getListaRegistros(); 
        }

        return (
            <span style={{}}>
                <span>{label}</span>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    showSearch
                    style={{ width: width }}
                />
            </span>
        );
    }
}

export default CondPagtoFrame;



// WEBPACK FOOTER //
// ./src/components/CondPagtoFrame.js